var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.3125C7.17861 10.3125 8.4375 9.05361 8.4375 7.5V2.8125C8.4375 1.25889 7.17861 0 5.625 0C4.07139 0 2.8125 1.25889 2.8125 2.8125V7.5C2.8125 9.05273 4.0459 10.3125 5.625 10.3125ZM10.0781 5.625C9.68848 5.625 9.375 5.93848 9.375 6.30176V7.5C9.375 9.64834 7.55947 11.3789 5.38184 11.2412C3.4459 11.1191 1.875 9.29033 1.875 7.35059V6.30176C1.875 5.93848 1.56006 5.625 1.17188 5.625C0.783691 5.625 0.46875 5.93848 0.46875 6.30176V7.24365C0.46875 9.87041 2.34287 12.2124 4.92188 12.5669V13.5938H3.75C3.21709 13.5938 2.78789 14.0385 2.81367 14.5772C2.8251 14.8184 3.04102 15 3.28125 15H7.96875C8.20963 15 8.4249 14.8179 8.43633 14.5772C8.46094 14.0391 8.0332 13.5938 7.5 13.5938H6.32812V12.6044C8.83887 12.2607 10.7812 10.1045 10.7812 7.5V6.30176C10.7812 5.93848 10.4678 5.625 10.0781 5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.8e354ad6cbcc7466512705d80da49ecf.svg";
export { ForwardRef as ReactComponent };